import React, {useEffect} from 'react';

const CalendarScrollbar = () => {
    useEffect(() => {
        const createCalendarScrollbar = () => {
            const originalScrollbar = document.querySelector(
                "#root > div > div > div.calendar-wrapper > div > div > div.fc-view-harness.fc-view-harness-passive > div.fc-resourceTimelineDay-view.fc-view.fc-resource-timeline.fc-timeline.fc-timeline-overlap-enabled > table > tfoot > tr > th:nth-child(3) > div > div"
            );
            const calendarView = document.querySelector(
                "#root > div > div > div.calendar-wrapper > div > div > div.fc-view-harness.fc-view-harness-passive > div.fc-resourceTimelineDay-view.fc-view.fc-resource-timeline.fc-timeline.fc-timeline-overlap-enabled"
            );
            const pluginScrollBar = document.querySelector("#root > div > div > div.calendar-wrapper > div > div > div.fc-view-harness.fc-view-harness-passive > div.fc-resourceTimelineDay-view.fc-view.fc-resource-timeline.fc-timeline.fc-timeline-overlap-enabled > table > tfoot > tr > th:nth-child(3) > div > div");

            if (originalScrollbar && calendarView) {
                const clonedScrollbar = originalScrollbar.cloneNode(true);
                clonedScrollbar.id = 'custom-cloned-scrollbar';
                clonedScrollbar.style.cssText = `
                ${originalScrollbar.style.cssText}
                position: absolute;
                top: -20px;
                left: 10%;
                width: 90%;
                z-index: 10;`;

                const existingScrollbar = document.getElementById('custom-cloned-scrollbar');
                if (existingScrollbar) {
                    existingScrollbar.remove();
                }

                calendarView.parentNode.insertBefore(clonedScrollbar, calendarView);

                const syncScroll = () => {
                    clonedScrollbar.scrollLeft = pluginScrollBar.scrollLeft;
                };

                const syncReverseScroll = () => {
                    pluginScrollBar.scrollLeft = clonedScrollbar.scrollLeft;
                };

                clonedScrollbar.addEventListener('scroll', syncReverseScroll);
                pluginScrollBar.addEventListener('scroll', syncScroll);

                return () => {
                    clonedScrollbar.removeEventListener('scroll', syncReverseScroll);
                    pluginScrollBar.removeEventListener('scroll', syncScroll);
                };
            }
        };

        const cleanup = createCalendarScrollbar();

        return () => {
            if (cleanup) {
                cleanup();
            }
        };
    }, []);

    return null
};

export default CalendarScrollbar;
